import Layout from "@/admin/js/layout/index.vue";

const helpRoutes = {
    path: '/help',
    component: Layout,
    redirect: '/help',
    children: [
        {
            path: 'docs',
            component: () => import('@/admin/js/views/help/docs.vue'),
            name: 'HelpDocs',
            meta: { title: 'Документация', noCache: false }
        },
        {
            path: 'consumption',
            component: () => import('@/admin/js/views/help/consumption.vue'),
            name: 'HelpConsumption',
            meta: { title: 'Расходка', noCache: false }
        }
    ]
}
export default helpRoutes;
